import { useEffect, useState } from "react";

const calculateVirtualKeyboardHeight = () =>
  window.visualViewport ? window.innerHeight - window.visualViewport.height : 0;

export const useIsVirtualKeyboardOpen = () => {
  const [virtualKeyboardHeight, setVirtualKeyboardHeight] = useState<number>(0);
  const isVirtualKeyboardOpen = virtualKeyboardHeight > 0;

  useEffect(() => {
    const listener = () => {
      setVirtualKeyboardHeight(calculateVirtualKeyboardHeight());
    };

    window.visualViewport?.addEventListener("resize", listener);

    return () => {
      window.visualViewport?.removeEventListener("resize", listener);
    };
  }, []);

  return { isVirtualKeyboardOpen, virtualKeyboardHeight };
};
